"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/esnext.iterator.map.js");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Global components
 * By Bhargav Shivaprasad <bshivaprasad@svb.com> (www.svb.com)
 * Summary
 * This component renders an SVB Solutions Headers
 */

/**
 *
 * @param title: Title for the solution header
 * @param subTitle: Subtitle for the solutions header
 * @param description: Description text
 * @param headerImage: Right side image for the solutions header
 * @param headerIcon: Icon below title text
 * @param breadcrumbs: Array of objects containing the display text and path of the current navigation path
 * @returns SVB Solutions Headers as per SVB Design
 */
const SVBSolutionsHeader = props => {
  var _props$title, _props$subTitle, _props$description, _props$headerImage, _props$breadcrumbs, _breadCrumbs, _breadCrumbs2;
  const title = (_props$title = props === null || props === void 0 ? void 0 : props.title) !== null && _props$title !== void 0 ? _props$title : '';
  const subTitle = (_props$subTitle = props === null || props === void 0 ? void 0 : props.subTitle) !== null && _props$subTitle !== void 0 ? _props$subTitle : '';
  const description = (_props$description = props === null || props === void 0 ? void 0 : props.description) !== null && _props$description !== void 0 ? _props$description : '';
  const headerImage = (_props$headerImage = props === null || props === void 0 ? void 0 : props.headerImage) !== null && _props$headerImage !== void 0 ? _props$headerImage : '';
  const headerIcon = props.headerIcon !== '' ? require('@svb/svbbranding/dist/assets/icons' + props.headerIcon) : '';
  let breadCrumbs = (_props$breadcrumbs = props === null || props === void 0 ? void 0 : props.breadcrumbs) !== null && _props$breadcrumbs !== void 0 ? _props$breadcrumbs : '[]';
  breadCrumbs = breadCrumbs.replace(/'/g, '"');
  breadCrumbs = JSON.parse(breadCrumbs);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "svb-solutions-header-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "svb-solutions-header-left-column"
  }, ((_breadCrumbs = breadCrumbs) === null || _breadCrumbs === void 0 ? void 0 : _breadCrumbs.length) > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "svb-solutions-header-breadcrumbs-margin"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list breadcrumbs--workspace d-flex align-center pl-24 pr-24"
  }, (_breadCrumbs2 = breadCrumbs) === null || _breadCrumbs2 === void 0 ? void 0 : _breadCrumbs2.map((item, index) => {
    var _breadCrumbs3, _breadCrumbs4;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement("li", {
      className: "d-flex"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: item.href,
      className: ((_breadCrumbs3 = breadCrumbs) === null || _breadCrumbs3 === void 0 ? void 0 : _breadCrumbs3.length) === index ? 'last-child svb-solutions-header-color-white' : 'svb-solutions-header-color-white'
    }, item.displayText), ((_breadCrumbs4 = breadCrumbs) === null || _breadCrumbs4 === void 0 ? void 0 : _breadCrumbs4.length) - 1 !== index && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "faq-text02 oLDOtherLabel svb-solutions-header-color-white"
    }, "/"))));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "svb-solutions-header-text-container"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "heading-small svb-solutions-header-color-white"
  }, subTitle), /*#__PURE__*/_react.default.createElement("h1", {
    className: "heading-xlarge svb-solutions-header-color-white svb-solutions-header-padding-top-16"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "solution-header-content-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: headerIcon,
    className: "svb-solutions-header-icon svb-solutions-header-padding-top-16",
    alt: "soluton header icon",
    width: 320,
    height: 100
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "heading small svb-solutions-header-pre-line svb-solutions-header-color-white svb-solutions-header-padding-top-16"
  }, description))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "svb-solutions-header-right-column"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: headerImage,
    className: "svb-solutions-header-image",
    alt: "solutions Header right background",
    width: 320,
    height: 470
  })));
};
var _default = exports.default = SVBSolutionsHeader;